import React from 'react'
import { Modal } from 'react-bootstrap'
import DetailDoctor from './index'

export default class modal extends React.Component {

    render() {
        const {ShowModal1, cancelHandler} = this.props

        return (
            <div class="mb-10">
                <Modal show={ShowModal1} onHide={cancelHandler}>
                    <Modal.Header closeButton>
                        <Modal.Title>Gagal</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        <div class="modal-body text-center hapus">
                            <img src="assets/img/sent.png" alt="" width="50" height="46" />
                            <p> </p>
                            <p>Fungsi Belum Tersedia. </p>
                        </div>
                    </Modal.Body>

                    <Modal.Footer>
                        <button type="button" class="btn btn-light" onClick={cancelHandler}>Kembali</button>
                    </Modal.Footer>
                </Modal>
            </div>
         
        )
    }
}
